import type { Locale } from "../types/locale.types";

export const DEFAULT_LOCALE: Locale = "en";
